import _http_v1 from "@packs/http_requests/_http_v1"

const geoJSONHelper = {
    featureLayer:undefined,
    ugrhiFeatures: [],
    addLimitLayerToMap(map, limit, params){
        this.clearFeatureLayer()
        this.getLimitFeatureGroup(limit, params).then(feature=>{
            this.featureLayer = feature
            this.featureLayer.addTo(map)
        })
        
    },
    loadUgrhisFeatures(){
        this.getLimitFeatures('ugrhi_limit', {simplified:true}).then(layers=>{
            this.ugrhiFeatures = layers
        })
    },
    async getLimitFeatureGroup(limit,params){
        let response = await _http_v1.request(`maps/${limit}`, 'GET', params)
        let featureGroup = new L.featureGroup()
        let style = {
            color: "#0275d8",
            fillOpacity: 0.1,
            weight: 2,
            opacity: 0.65
        }
        response.forEach(line=>{
            let layer = L.geoJSON(JSON.parse(line.geometry_json), style) 
            featureGroup.addLayer(layer)
        })
        return featureGroup
    },
    async getLimitFeatures(limit,params){
        let response = await _http_v1.request(`maps/${limit}`, 'GET', params)
        let layers = []
        let style = {
            color: "#0275d8",
            fillOpacity: 0.1,
            weight: 2,
            opacity: 0.65
        }
        response.forEach(line=>{
            let layer = L.geoJSON(JSON.parse(line.geometry_json), style) 
            if(limit === 'ugrhi_limit'){
                layer.cod = line.codigo
            } else if(limit === 'city_limit'){
                layer.cod_ibge = line.cod_ibge
                layer.name = line.name
            }
            layers.push(layer)
        })
        return layers
    },
    async getLimits(limit,params){
        let response = await _http_v1.request(`maps/${limit}`, 'GET', params)
        return response
    },
    clearFeatureLayer(){
        if(this.featureLayer){
            this.featureLayer.clearLayers()
        }
    }
}

export default geoJSONHelper